export enum PerceptionModalTypes {
    OPEN_PERCEPTION_MODAL = '[auth] OPEN_PERCEPTION_MODAL',
    CLOSE_PERCEPTION_MODAL = '[auth] CLOSE_PERCEPTION_MODAL',
    REACTIVE_PERCEPTION_COL = '[auth] REACTIVE_PERCEPTION_COL',
    UPDATE_PERCEPTIONS ='[auth] UPDATE_PERCEPTIONS',
}